/** The Stop element: ends the run as completed. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowStepType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Ends the run as completed; steps after it never run. */
export const STOP_ELEMENT: WorkflowElement = {
    type: WorkflowStepType.Stop,
    family: WorkflowFamily.Flow,
    sideEffect: WorkflowSideEffect.None,
    title: 'Stop',
    icon: 'fa-circle-stop',
    fields: [
        {
            bind: 'reason',
            bindable: true,
            renderer: WorkflowFieldRenderer.MergeText,
            metadata: {
                displayName: 'Reason',
                type: MetadataEntityFieldType.String,
            },
        },
    ],
    outputs: [],
};
